import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import compose from "recompose/compose";
import {
  setSidebarVisibility as setSidebarVisibilityAction
} from "admin-on-rest";
import withWidth from "material-ui/utils/withWidth";
import "../../App.css";
import DesktopLayout from "./DesktopLayout";
import {saveConfiguration as saveConfigurationAction} from "../../actions/saveConfiguration";
import { withRouter } from 'react-router-dom';

class Layout extends Component {
  async componentWillMount() {
    if (this.props.width !== 1) {
      this.props.setSidebarVisibility(true);
    }
    const loggedIn = localStorage.getItem("role") ? true : false;
    if(!loggedIn) this.props.history.replace(`/login`);
  }

  async componentDidMount() {
    try {
      var response = await fetch(
        `${process.env.REACT_APP_API_URL}/configuration`,
        {
          method: "GET",
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json"
          }
        }
      );
      var configuration = await response.json();
      this.props.saveConfiguration(configuration);
    } catch (e) {
      console.log("error");
    }
  }

  render() {
    const {children, dashboard, isLoading, logout, menu, title} = this.props;

    return (
      <DesktopLayout
        children={children}
        dashboard={dashboard}
        isLoading={isLoading}
        logout={logout}
        menu={menu}
        title={title}
        configuration={this.props.configuration}
      />
    );
  }
}

Layout.propTypes = {
  authClient: PropTypes.func,
  customRoutes: PropTypes.array,
  dashboard: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  isLoading: PropTypes.bool.isRequired,
  resources: PropTypes.array,
  setSidebarVisibility: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.number
};

function mapStateToProps(state) {
  return {
    isLoading: state.admin.loading > 0,
    configuration: state.configuration
  };
}

const enhance = compose(
  connect(
    mapStateToProps,
    {
      setSidebarVisibility: setSidebarVisibilityAction,
      saveConfiguration: saveConfigurationAction
    }
  ),
  withWidth()
);

export default enhance(withRouter(Layout));



// WEBPACK FOOTER //
// ./src/components/Layout/index.js